import {gql} from "@irati/utils/gql"
import fullPaymentOrder from "@irati/payments/services/fragments/fullPaymentOrder"
import partialCheckoutRedemption from "./partialCheckoutRedemption"
import fullBasket from "./fullBasket"

const fullCheckout = gql`
  fragment fullCheckout on Checkout {
    uuid
    failureReason
    metadata {
      createdAt
    }
    basket {
      ...fullBasket
    }
    paymentOrder {
      ...fullPaymentOrder
    }
    fullRedemptions {
      ...partialCheckoutRedemption
    }
    fullRedemptions {
      order {
        products {
          items {
            provider
          }
        }
      }
    }
    status
  }
  ${partialCheckoutRedemption}
  ${fullPaymentOrder}
  ${fullBasket}
`

export default fullCheckout
